/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { TechCamPhotoOffIcon16Light } from './TechCamPhotoOffIcon16Light';
import { TechCamPhotoOffIcon16Regular } from './TechCamPhotoOffIcon16Regular';
import { TechCamPhotoOffIcon16Solid } from './TechCamPhotoOffIcon16Solid';
import { TechCamPhotoOffIcon20Light } from './TechCamPhotoOffIcon20Light';
import { TechCamPhotoOffIcon20Regular } from './TechCamPhotoOffIcon20Regular';
import { TechCamPhotoOffIcon20Solid } from './TechCamPhotoOffIcon20Solid';
import { TechCamPhotoOffIcon24Regular } from './TechCamPhotoOffIcon24Regular';
import { TechCamPhotoOffIcon24Solid } from './TechCamPhotoOffIcon24Solid';
import { TechCamPhotoOffIcon32Regular } from './TechCamPhotoOffIcon32Regular';
import { TechCamPhotoOffIcon64Regular } from './TechCamPhotoOffIcon64Regular';
var sizes = {
    16: {
        light: TechCamPhotoOffIcon16Light,
        regular: TechCamPhotoOffIcon16Regular,
        solid: TechCamPhotoOffIcon16Solid,
    },
    20: {
        light: TechCamPhotoOffIcon20Light,
        regular: TechCamPhotoOffIcon20Regular,
        solid: TechCamPhotoOffIcon20Solid,
    },
    24: {
        regular: TechCamPhotoOffIcon24Regular,
        solid: TechCamPhotoOffIcon24Solid,
    },
    32: {
        regular: TechCamPhotoOffIcon32Regular,
    },
    64: {
        regular: TechCamPhotoOffIcon64Regular,
    },
};
export var TechCamPhotoOffIcon = forwardRef('TechCamPhotoOffIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
